export const Constants = {
  appName: 'Lienstar Portal',
  headerHeight: 65,
  defaultPolicyLimitPercentage: 5,
  defaultRate: 10,
  replacementColor: '#83619F',
}
